/**
 * Returns the appropriate menu portal target for react-select based on the device type.
 * @param {boolean} isSmallDevice - Indicates whether the current device is a small device.
 * @returns {HTMLElement|null} - The DOM element to be used as the menu portal target, or null for small devices.
 */
export const getMenuPortalTarget = (isSmallDevice) => {
  let menuPortalTarget = document.body;

  if (isSmallDevice === true) {
    menuPortalTarget = null;
  }

  return menuPortalTarget;
};
